import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import Logo from './Logo'; // Logonuzu import ettiğinizden emin olun


// MUI Bileşenleri
import {
    AppBar as MuiAppBar, // Orijinal MUI AppBar'ı kullanacağız
    Box,
    CssBaseline,
    Drawer as MuiDrawer, // Orijinal MUI Drawer'ı kullanacağız
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography,
    Avatar,
    Menu,
    MenuItem,
    Divider,
    Tooltip,
    ListSubheader,
    useMediaQuery
} from '@mui/material';
// Stil ve Tema importları
import { styled, useTheme } from '@mui/material/styles';

// MUI İkonları
import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'; // Artık kullanılmıyor
import HomeIcon from '@mui/icons-material/Home';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import HistoryIcon from '@mui/icons-material/History';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PostAddIcon from '@mui/icons-material/PostAdd';
import EditIcon from '@mui/icons-material/Edit';
import ScienceIcon from '@mui/icons-material/Science';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupIcon from '@mui/icons-material/Group';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import GridOnIcon from '@mui/icons-material/GridOn';
import ChecklistIcon from '@mui/icons-material/Checklist';
import BuildIcon from '@mui/icons-material/Build';
import AssignmentIcon from '@mui/icons-material/Assignment';

const drawerWidth = 280; // Tam açık menü genişliği

// --- YENİ Stiller ---
// Bu stiller, menü kağıdının (paper) genişliğini kontrol edecek
const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(8)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

// YENİ: AppBar (Üst Bar) stili. Artık menüden bağımsız.
const AppBar = styled(MuiAppBar)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1, // Menünün (varsa) üstünde
    backgroundColor: theme.palette.background.paper,
    backgroundImage: 'none',
    color: theme.palette.text.primary,
    borderBottom: '1px solid',
    borderColor: theme.palette.divider,
    elevation: 0,
}));

// YENİ: "Float-on-Hover" için Drawer (Yan Menü) stili
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth, // Bu, stil bileşeninin genişliği değil, kapsayıcının
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',

        // MuiDrawer-paper (içerik) hover ile genişler
        '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            overflowX: 'hidden',
            // AppBar'ın ALTINDAN başla
            top: '65px', // AppBar yüksekliği (64px + 1px border)
            height: 'calc(100% - 65px)', // Tam yükseklik
            ...(open ? openedMixin(theme) : closedMixin(theme)), // Açık veya kapalı stil
        },
    }),
);
// --- Stiller Bitiş ---

// --- Menü Linkleri (Değişiklik yok) ---
const userLinks = [
    { text: 'Ana Sayfa', icon: <HomeIcon />, path: '/home' },
    { text: 'Eğitim Geçmişim', icon: <HistoryIcon />, path: '/my-courses' },
];
const adminDashboardLink = [
    { text: 'Admin Paneli', icon: <AdminPanelSettingsIcon />, path: '/admin' },
];
const adminActionLinks = [
    { text: 'Yeni Eğitim Ekle', icon: <PostAddIcon />, path: '/admin/add-course' },
    { text: 'Eğitim Düzenle', icon: <EditIcon />, path: '/admin/edit-course' },
    { text: 'Eğitim Test Et', icon: <ScienceIcon />, path: '/admin/test-course' },
    { text: 'Yeni Kullanıcı Ekle', icon: <PersonAddIcon />, path: '/admin/add-user' },
    { text: 'Sertifika Onayları', icon: <VerifiedUserIcon />, path: '/admin/approvals' },
];
const adminManagementLinks = [
    { text: 'Kullanıcı Yönetimi', icon: <GroupIcon />, path: '/admin/manage-users' },
    { text: 'Eğitim Ata', icon: <AddCircleOutlineIcon />, path: '/admin/assign-course' },
    { text: 'Zorunluluk Tanımla', icon: <PlaylistAddCheckIcon />, path: '/admin/define-mandatory-courses' },
    { text: 'Harici Kayıt Ekle', icon: <NoteAddIcon />, path: '/admin/add-external-record' },
    { text: 'Eğitim Raporları', icon: <AssessmentIcon />, path: '/admin/reports/by-course' },
    { text: 'Kişi Raporları', icon: <FactCheckIcon />, path: '/admin/reports/by-person' },
    { text: 'Eğitim Takip Listesi', icon: <ChecklistIcon />, path: '/admin/education-followup' },
    { text: 'Eğitim Matrisi', icon: <GridOnIcon />, path: '/admin/training-matrix' },
    { text: 'Atama Listesi', icon: <AssignmentIcon />, path: '/admin/assignments' },
];
const devToolsLinks = [
    { text: 'Firestore Editörü', icon: <BuildIcon />, path: '/admin/dev-tools' },
];
// --- Linkler Bitiş ---


function MainLayout(props) {
    const { children } = props;
    const theme = useTheme();

    // Yan menü tıklamayla açılıp kapanır. Tercih tarayıcıda saklanır; MainLayout her rotada
    // yeniden kurulduğu için aksi halde her sayfa geçişinde menü kapanırdı.
    const [open, setOpen] = useState(() => {
        try { return localStorage.getItem('arca_sidebar_open') === '1'; } catch { return false; }
    });

    const [mobileOpen, setMobileOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser, isAdmin, userProfile, logout } = useAuth();

    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    // Menü düğmesi: masaüstünde kalıcı menüyü, mobilde geçici menüyü açıp kapatır
    const handleDrawerToggle = () => {
        if (isDesktop) {
            setOpen(prev => {
                const next = !prev;
                try { localStorage.setItem('arca_sidebar_open', next ? '1' : '0'); } catch { /* gizli sekme vb. */ }
                return next;
            });
        } else {
            setMobileOpen(prev => !prev);
        }
    };

    // Kullanıcı menüsü
    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleLogout = async () => {
        handleClose();
        try {
            await logout();
            navigate('/');
        } catch (error) { console.error('Çıkış hatası:', error); }
    };

    const displayName = userProfile?.firstName || userProfile?.kullaniciAdi || currentUser?.email;
    const displayInitial = displayName ? displayName[0].toUpperCase() : 'K';

    // Kapalı (mini) menünün sabit genişliği
    const miniDrawerWidth = `calc(${theme.spacing(9)} + 1px)`;

    // Kaydırma çubuğu stili (lacivert menü zeminine göre)
    const scrollbarStyles = {
        '&::-webkit-scrollbar': { width: '6px', backgroundColor: theme.palette.primary.main },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(255,255,255,0.25)', borderRadius: '3px' },
        '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(255,255,255,0.4)' },
        'scrollbarWidth': 'thin',
        'scrollbarColor': `rgba(255,255,255,0.25) ${theme.palette.primary.main}`,
    };

    // "D · Marka Renkleri" tasarımı: lacivert yan menü
    // Menü zemini lacivert, yazılar açık; aktif öğe beyaz zemin + lacivert yazı + kırmızı ikon.
    // px/mx değerleri kapalı (mini) menü genişliğine göre: 73 - 8 - 40 = 25px, ikona tam yetiyor.
    const navItemSx = {
        minHeight: 48,
        px: 2.5,
        mx: 0.5,
        my: 0.25,
        borderRadius: 1,
        color: '#C9D3E3',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
        '&.Mui-selected': {
            bgcolor: '#FFFFFF',
            color: 'primary.main',
            '&:hover': { bgcolor: '#FFFFFF' },
            '& .MuiListItemIcon-root': { color: 'brand.red' },
            '& .MuiListItemText-primary': { fontWeight: 700 },
        },
    };
    const navIconSx = { minWidth: 0, justifyContent: 'center', color: 'inherit' };
    const navSubheaderSx = {
        lineHeight: '40px',
        bgcolor: 'transparent',
        color: '#8FA1BF',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    };
    const navDividerSx = { my: 1, borderColor: 'rgba(255,255,255,0.12)' };
    const drawerPaperSx = {
        bgcolor: 'primary.main',
        color: '#C9D3E3',
        borderColor: 'primary.dark',
    };


    // Menü içeriği (JSX)
    function drawerContent(isOpen) { // Parametre adı 'open' yerine 'isOpen'
        return (
            <Box sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
                {/* 1. MENÜ LİNKLERİ (Kaydırma için Box içinde) */}
                {/* Logo/Başlık artık AppBar'da, burası sadece listeler */}
                <Box sx={{ overflowY: 'auto', overflowX: 'hidden', ...scrollbarStyles }}>
                    {/* Kullanıcı Menüsü */}
                    <List subheader={
                        // DÜZELTME: Kapalıyken başlık render edilmiyor
                        isOpen ? (
                            <ListSubheader component="div" sx={navSubheaderSx}>
                                Kullanıcı Menüsü
                            </ListSubheader>
                        ) : null
                    }>
                        {userLinks
                            .filter(item => !(item.path === '/my-courses' && userProfile?.isGuest))
                            .map((item) => (
                                <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                    <ListItemButton
                                        component={RouterLink} to={item.path} selected={location.pathname === item.path}
                                        sx={{ ...navItemSx, justifyContent: isOpen ? 'initial' : 'center' }}
                                    >
                                        <ListItemIcon sx={{ ...navIconSx, mr: isOpen ? 3 : 'auto' }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText primary={item.text} sx={{ opacity: isOpen ? 1 : 0 }} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                    </List>

                    {/* Admin Menüleri */}
                    {isAdmin && (
                        <>
                            <Divider sx={navDividerSx} />
                            <List subheader={
                                isOpen ? (
                                    <ListSubheader component="div" sx={navSubheaderSx}>
                                        Yönetim Paneli
                                    </ListSubheader>
                                ) : null
                            }>
                                {adminDashboardLink.map((item) => (
                                    <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            component={RouterLink} to={item.path} selected={location.pathname === item.path}
                                            sx={{ ...navItemSx, justifyContent: isOpen ? 'initial' : 'center' }}
                                        >
                                            <ListItemIcon sx={{ ...navIconSx, mr: isOpen ? 3 : 'auto' }}>
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item.text} sx={{ opacity: isOpen ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider sx={navDividerSx} />
                            <List subheader={
                                isOpen ? (
                                    <ListSubheader component="div" sx={navSubheaderSx}>
                                        Hızlı Eylemler
                                    </ListSubheader>
                                ) : null
                            }>
                                {adminActionLinks.map((item) => (
                                    <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            component={RouterLink} to={item.path} selected={location.pathname.startsWith(item.path)}
                                            sx={{ ...navItemSx, justifyContent: isOpen ? 'initial' : 'center' }}
                                        >
                                            <ListItemIcon sx={{ ...navIconSx, mr: isOpen ? 3 : 'auto' }}>
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider sx={navDividerSx} />
                            <List subheader={
                                isOpen ? (
                                    <ListSubheader component="div" sx={navSubheaderSx}>
                                        Yönetim & Raporlar
                                    </ListSubheader>
                                ) : null
                            }>
                                {adminManagementLinks.map((item) => (
                                    <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            component={RouterLink} to={item.path} selected={location.pathname.startsWith(item.path)}
                                            sx={{ ...navItemSx, justifyContent: isOpen ? 'initial' : 'center' }}
                                        >
                                            <ListItemIcon sx={{ ...navIconSx, mr: isOpen ? 3 : 'auto' }}>
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider sx={navDividerSx} />
                            <List subheader={
                                isOpen ? (
                                    <ListSubheader component="div" sx={{ ...navSubheaderSx, color: 'warning.light' }}>
                                        ⚙ Dev Tools
                                    </ListSubheader>
                                ) : null
                            }>
                                {devToolsLinks.map((item) => (
                                    <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            component={RouterLink} to={item.path} selected={location.pathname.startsWith(item.path)}
                                            sx={{
                                                ...navItemSx,
                                                justifyContent: isOpen ? 'initial' : 'center',
                                                '&.Mui-selected': { bgcolor: 'warning.dark', color: '#FFFFFF', '& .MuiListItemIcon-root': { color: '#FFFFFF' } },
                                                '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
                                            }}
                                        >
                                            <ListItemIcon sx={{ ...navIconSx, mr: isOpen ? 3 : 'auto', color: 'warning.light' }}>
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item.text} sx={{ opacity: isOpen ? 1 : 0, color: 'warning.light' }} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/* Üst Bar (DÜZELTİLDİ: 100% genişlik) */}
            <AppBar position="fixed" elevation={0}>
                <Toolbar>
                    {/* Mobil menü butonu */}
                    {/* Menü düğmesi: her boyutta görünür, menüyü tıklamayla açıp kapatır */}
                    <IconButton
                        color="inherit"
                        aria-label={(isDesktop ? open : mobileOpen) ? 'Menüyü daralt' : 'Menüyü genişlet'}
                        aria-expanded={isDesktop ? open : mobileOpen}
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ marginRight: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/* Logo ve Başlık AppBar'a taşındı */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            // DÜZELTME: Sadece desktop'ta mini-menü kadar boşluk bırak
                            pl: { sm: `calc(${theme.spacing(1)} + 1px)` },
                            transition: 'padding 0.2s'
                        }}
                        onClick={() => navigate(isAdmin ? '/admin' : '/home')}
                    >
                        <Logo style={{ height: 40, transition: 'all 0.2s', flexShrink: 0 }} />
                    </Box>

                    <Box sx={{ flexGrow: 1 }} /> {/* Boşluk */}

                    {/* Kullanıcı Profili ve Logout (Değişiklik yok) */}
                    <div>
                        <Tooltip title="Hesap Ayarları">
                            <IconButton onClick={handleMenu} color="inherit">
                                <Avatar sx={{ bgcolor: 'primary.main', width: 36, height: 36 }}>
                                    {displayInitial}
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            anchorEl={anchorEl}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            keepMounted
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem disabled sx={{ opacity: '1 !important' }}>
                                <Typography variant="subtitle2" color="text.primary">
                                    Hoş geldin, {displayName}
                                </Typography>
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Çıkış Yap</ListItemText>
                            </MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>

            {/* --- Yan Menü (Sol) --- */}

            {/* 1. Mobil için Geçici Menü (AppBar'ın altından başlar) */}
            <MuiDrawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        ...drawerPaperSx,
                        ...scrollbarStyles,
                        top: '65px', // AppBar yüksekliği
                        height: 'calc(100% - 65px)',
                    },
                }}
            >
                {drawerContent(true)} {/* Mobil menü her zaman açık içeriklidir */}
            </MuiDrawer>

            {/* 2. Desktop için Kalıcı Menü (AppBar'ın altından başlar; üst çubuktaki düğmeyle açılıp kapanır) */}
            <Drawer
                variant="permanent"
                open={open}
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        ...drawerPaperSx,
                        ...scrollbarStyles,
                        top: '65px', // AppBar'ın altından başla
                        height: 'calc(100% - 65px)',
                    }
                }}
            >
                {drawerContent(open)}
            </Drawer>

            {/* Ana İçerik Alanı (İçeriği itiyor) */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 2, sm: 3 },
                    minHeight: '100vh',
                    bgcolor: 'background.default',
                    // YENİ: İçerik, menünün durumuna göre itiliyor
                    transition: theme.transitions.create('margin-left', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                    marginLeft: { sm: `calc(${theme.spacing(-9)} + 1px)` }, // Kapalı menü genişliği (Desktop)
                    ...(open && { // Menü açıkken (Desktop)
                        transition: theme.transitions.create('margin-left', {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                        marginLeft: { sm: `${drawerWidth}px` }, // Açık menü genişliği
                    }),
                }}
            >
                <Toolbar /> {/* AppBar'ın yüksekliği kadar boşluk bırakır */}
                {children}
            </Box>
        </Box>
    );
}

export default MainLayout;